import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/lib/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"../../public/fonts/PretendardVariable.woff2\",\"display\":\"swap\",\"weight\":\"45 920\",\"variable\":\"--font-pretendard\"}],\"variableName\":\"pretendard\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout-component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryProviders"] */ "/vercel/path0/src/providers/react-query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/providers/theme-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
